import { localeNumberWithFixed } from "psims/lib/formatters/numbers";
import { NotificationPart } from "../../../shared/notification-message";
import { ACCValidationField, ACCValidationResult } from "./aus-control-corps-validations";

const FIELD_LABELS: { [key in ACCValidationField]: string } = {
  newCorporationName: 'New corporation name',
  abn: 'ABN',
  acn: 'ACN',
  address: 'Address',
  contactInformation: 'Contact information',
  comments: 'Comments',
};

export function getACCNotificationMessage(
  fieldName: ACCValidationField,
  onTargetClick: () => any,
  validationResult: ACCValidationResult | null,
): Array<NotificationPart> | undefined {
  if (validationResult == null) return undefined;

  const label = FIELD_LABELS[fieldName];
  const btn = { label: `Go to ${label} field`, onClick: onTargetClick, text: label };
  const parts: Array<NotificationPart> = [];

  switch (validationResult.code) {
    case 'invalid_required':
      parts.push('A value for ');
      parts.push(btn);
      parts.push(' is required.');
      break;

    case 'character_limit':
      parts.push('The value in ');
      parts.push(btn);
      parts.push(` must be ${localeNumberWithFixed(validationResult.limit)} characters or fewer.`);
      break;

    case 'invalid_characters':
      parts.push('The value in ');
      parts.push(btn);
      parts.push(' must only contain letters, numbers, hyphens, apostrophes, and parentheses.');
      break;
    case 'invalid_length':
      parts.push('The value in ');
      parts.push(btn);
      parts.push(` must be exactly ${validationResult.requiredLength} characters.`);
      break;
    case 'numeric_only':
        parts.push('The value in ');
        parts.push(btn);
        parts.push(` must contain numbers only.`);
      break;  
    case 'abn_or_acn_required':
        parts.push('Either ');
        parts.push(btn);
        parts.push(' or ');
        parts.push({ label: 'Go to ACN field', onClick: onTargetClick, text: 'ACN' });
        parts.push(' must be provided.');
      break;  
    case 'invalid_abn_acn_format':
      parts.push('The value in ');
      parts.push(btn);
      parts.push(` field must be exactly ${validationResult.requiredLength} digits, without letters, space or special characters.`);
      break;
       
  }

  return parts;
}